import React from 'react'

export default function UnshieldIconSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-shield-off"
    >
      <path d="M19.69 14a9.7 9.7 0 0 0 .31-2V7a1 1 0 0 0-1-1c-2 0-4.5-1.2-6.24-2.72a1.17 1.17 0 0 0-1.52 0c-.61.53-1.29 1.03-2.05 1.43" />
      <path d="M4 7v5c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.12-.74 3.94-1.8 5.37-3.19" />
      <path d="m2 2 20 20" />
    </svg>
  )
}
